/* File: frontend/src/pages/Home.js */
/* Version: 9.0 (Clean Text Layout) */

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css';

const coreFeatures = [
    { 
        id: 1, 
        icon: "📂", 
        title: "Document Management", 
        desc: "Centralize and process all your legal documents efficiently.", 
        position: "pos-top" 
    },
    { 
        id: 2, 
        icon: "📊", 
        title: "Advanced Analytics", 
        desc: "Gain deep insights with comprehensive reporting on all processes.", 
        position: "pos-right" 
    },
    { 
        id: 3, 
        icon: "⚙️", 
        title: "Process Automation", 
        desc: "Automate routine legal tasks and improve your workflow.", 
        position: "pos-left" 
    },
];

const Home = () => {
    const navigate = useNavigate();
    const [branding, setBranding] = useState({ company_name: 'Legal OS', project_name: 'Legal OS' });

    useEffect(() => {
        fetch('/api/v1/branding').then(r => r.json()).then(data => setBranding(data)).catch(() => {});
    }, []);

    return (
        <div className="home-page">
            
            {/* --- 1. ORBIT SECTION (Верхняя часть) --- */}
            <section className="orbit-section">
                <div className="orbit-container fade-in">
                    {/* ЛОГОТИП В ЦЕНТРЕ */}
                    <div className="orbit-center">
                        <div className="pulse-circle"></div>
                        <img src="/logo192.png" alt="NYGot Core" />
                    </div>

                    {/* ПАРЯЩИЕ КАРТОЧКИ */}
                    {coreFeatures.map((feat) => (
                        <div key={feat.id} className={`orbit-card ${feat.position}`}>
                            <div className="card-icon">{feat.icon}</div>
                            <div className="card-text">
                                <h4>{feat.title}</h4>
                                <p>{feat.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* --- 2. TEXT & CTA SECTION (Нижняя часть) --- */}
            <section className="text-section">
                <div className="text-content">
                    <h1 className="hero-title">WELCOME TO {branding.project_name?.toUpperCase() || 'LEGAL OS'}</h1>

                    <p className="hero-subtitle">
                        The custom Operating System for <span className="highlight">{branding.company_name}.</span>
                    </p>
                    
                    <p className="hero-powered">
                        POWERED BY NYGOT TECHNOLOGY
                    </p>
                    
                    {/* Кнопка ровно под текстом */}
                    <button className="btn-get-started" onClick={() => navigate('/login')}>
                        Get Started
                    </button>
                </div>
            </section>

        </div>
    );
};

export default Home;